import { SET_NEW_PASSWORD_FAILURE, SET_NEW_PASSWORD_SUCCESS } from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case SET_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case SET_NEW_PASSWORD_FAILURE:
      return { ...state, isLoading: false, errorData: action.payload, error: true };
    default:
      return { ...state };
  }
};
